import { useEffect } from "react";
import { PageHero } from "../components/pages/Blocks";
import { Contact } from "../components/landing/Contact";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact & Connect | Wings of Fire Foundation";
  }, []);
  return (
    <div data-testid="page-contact">
      <PageHero eyebrow="Contact Us" title="Reach Out To Us For More Information" intro="Provide feedback or ask how we can work together. Contact us to learn how to volunteer, donate, or partner with us." image="/images/p3.jpg" />
      <Contact />
    </div>
  );
}
